// generated from 11_746 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const genderFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("gender_filter"),
  comparison_key: z.enum([
    "1", // 9_832 (83.71%)
    "2", // 1_914 (16.29%)
  ]),
  display_name: z.string(),
  // undefined: 3_326 (28.32%), defined 8_420 (71.68%)
  raw_value: z
    .enum([
      "male", // 5_969 (70.89%)
      "female", // 2_014 (23.92%)
      "unknown", // 321 (3.81%)
      "not applicable", // 61 (0.72%)
      "other", // 32 (0.38%)
      "prefer not to say", // 23 (0.27%)
    ])
    .optional(),
  value: z.enum([
    "male", // 7_870 (67.00%)
    "female", // 3_435 (29.24%)
    "unknown", // 325 (2.77%)
    "not applicable", // 61 (0.52%)
    "other", // 32 (0.27%)
    "prefer not to say", // 23 (0.20%)
  ]),
  varies_by_app_group: z.literal(false),
});
